import {css} from "@emotion/react";
import styled from "@emotion/styled";


export const Backdrop = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(67, 72, 100, 0.35);
    z-index: 201;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 64px;
`;


export const ModalContentWrapper = styled.div`
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 0 30px rgba(67, 72, 100, 0.15);
    display: flex;
    flex-direction: column;
`;

export const ModalTitle = styled.div`   
    font-size: 25px;
`;


export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 35px 35px 0 48px;
`;


export const ModalContent = styled.div`
    width: 1200px;
    max-height: calc(100vh - 150px);
    overflow: auto;
`;

export const modalEnter = css`
    opacity: 0;
`;

export const modalEnterActive = css`
    opacity: 1;
    transition: opacity 200ms ease-in;
`;


export const modalExit = css`
    opacity: 1;
`;

export const modalExitActive = css`
    opacity: 0;
    transition: opacity 200ms ease-out;
`;